// feature/termino-hours — single source of truth for term values + display formatting.

export const TERMINO_OPTIONS = [1, 2, 4, 8, 10, 12, 24, 48, 72, 100];

// Format an integer hours value into a friendly Spanish label.
// Examples: 1 → "1 hora", 12 → "12 horas", 48 → "48 horas (2 días)",
//           100 → "100 horas (~4 días)".
export function formatTermino(hours) {
  if (hours == null || hours === "") return "—";
  const h = Number(hours);
  if (!Number.isFinite(h)) return "—";
  if (h < 24) return `${h} hora${h > 1 ? "s" : ""}`;
  if (h % 24 === 0) {
    const d = h / 24;
    return `${h} horas (${d} día${d > 1 ? "s" : ""})`;
  }
  return `${h} horas (~${Math.round(h / 24)} días)`;
}
